import moment from "moment";

export function getDateRangeObject(start, end) {
  return {
    start_date: start,
    end_date: end,
  };
}

export function formatDate(dateString) {
  if (dateString === "" || dateString === null) return dateString;
  const date = moment(dateString);
  return date.format("YYYY-MM-DD");
}
